var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15091_82043)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8526 11.3646L5.77244 11.3646C5.57782 11.3646 5.39292 11.2795 5.26627 11.1318L2.98055 8.4651C2.76656 8.21544 2.76656 7.84704 2.98055 7.59738L5.26627 4.93071C5.39292 4.78295 5.57782 4.69791 5.77244 4.69791L12.8526 4.69791C13.2208 4.69791 13.5192 4.99639 13.5192 5.36458L13.5192 10.6979C13.5192 11.0661 13.2208 11.3646 12.8526 11.3646ZM4.25393 4.06299C4.63389 3.6197 5.18859 3.36458 5.77244 3.36458H12.8526C13.9571 3.36458 14.8526 4.26001 14.8526 5.36458L14.8526 10.6979C14.8526 11.8025 13.9571 12.6979 12.8526 12.6979L5.77244 12.6979C5.18859 12.6979 4.63389 12.4428 4.25392 11.9995L1.96821 9.33282C1.32623 8.58384 1.32623 7.47864 1.96821 6.72966L4.25393 4.06299Z",
    fill: "#272B30"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.85932 7.80213L10.7449 9.68775C11.0053 9.9481 11.4274 9.9481 11.6878 9.68775C11.9481 9.4274 11.9481 9.00529 11.6878 8.74494L9.80213 6.85932C9.54178 6.59898 9.11967 6.59898 8.85932 6.85932C8.59898 7.11967 8.59898 7.54178 8.85932 7.80213Z",
    fill: "#272B30"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.80213 9.68755L11.6878 7.80193C11.9481 7.54158 11.9481 7.11947 11.6878 6.85912C11.4274 6.59877 11.0053 6.59877 10.7449 6.85912L8.85932 8.74474C8.59898 9.00509 8.59898 9.4272 8.85932 9.68755C9.11967 9.9479 9.54178 9.9479 9.80213 9.68755Z",
    fill: "#272B30"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15091_82043"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClear);
export default __webpack_public_path__ + "static/media/clear.8b9ad38aa341b520a62f2bd9b478a513.svg";
export { ForwardRef as ReactComponent };